import { useCallback } from 'react'
import { queueApi } from '@spcc/domains/queue'
import { selectAuthUser } from '@spcc/domains/auth'
import type { Order } from '@spcc/domains/orders'
import { useAppSelector } from '@/store/hooks'

/**
 * Self-service queue join for the order drawer. Rejections (not allowed,
 * already queued, no truck assigned) throw, and the drawer shows its error state.
 */
export function useQueueJoin() {
  const canJoinQueue = useAppSelector(selectAuthUser)?.tenant?.allowPortalQueueJoin === true
  const joinQueue = useCallback(async (order: Order) => {
    await queueApi.queueEntries.join({ orderId: order.id })
  }, [])
  return { canJoinQueue, joinQueue }
}
